import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { changeBookBackgroundType } from "./../../../../../../redux/actions/ui/bookProperties";
import { getCoverOrientation } from "./../../../../../../redux/helpers";

// Pro / consumer beliv
import loadProBelivTemplates from "./../../../../../../config/templates/layouts/pro";
import loadConsumerBelivTemplates from "./../../../../../../config/templates/layouts/consumer";

import { loadLayouts } from "./../../../../../../redux/actions/entities/layouts";
import cover from "../../../../../../redux/helpers/cover";

class ParentCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
    };
  }

  componentDidMount() {
    const { lang } = this.props;
  
      this.setState({
        categories: [
          {
            value: lang.modern,
            name: "modern",
          },
          {
            value: lang.tematic,
            name: "tematikus",
          },
        ],
      });
    
  }

  setBackgroundType = (type) => {
    this.props.dispatch(changeBookBackgroundType(type));
    this.loadSelectedBelivLayouts(type);
  };

  loadSelectedBelivLayouts = (type) => {
    const { dimensions } = this.props;
    const format = getCoverOrientation(
      dimensions.pageWidth,
      dimensions.pageHeight
    );
    // Load beliv layouts (pro or consumer)
    const pageType =
      type === "modern" ? loadProBelivTemplates : loadConsumerBelivTemplates;
    // Load pro layouts in pro book, consumer layouts will load after selected backgorund
    const layoutTemplates = pageType[format];
    for (const layout of layoutTemplates.items) {
      this.props.dispatch(loadLayouts(layout.layouts));
    }
  };

  displayComponent = () =>
    this.state.categories.map((element, index) => (
      <li
        key={`parent-${index}`}
        onClick={() => {
          this.setBackgroundType(element.name);
        }}
      >
        {element.value}
      </li>
    ));

  render() {
    return (
      <div className="listBody ">
        <ol>{this.displayComponent()}</ol>
      </div>
    );
  }
}

ParentCategory.defaultProps = {
  dimensions: {},
  lang: {},
};

ParentCategory.propTypes = {
  dimensions: PropTypes.object,
  lang: PropTypes.object,
};

export default connect()(ParentCategory);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/page-background-color/parent-category/ParentCategory.jsx